import { useNavigate } from "react-router-dom";
import { useDialog } from "@platform/store";
import type { Article } from "@core/features/support";
import { useFetchSupportArticles } from "@core/features/support";
import { useSupportSheet } from "@platform/store";
import { useIsSupportPage } from "../../forms/SearchForm/useIsSupportPage";
import { SupportPageContent, type Props as SupportPageContentProps } from "./SupportPageContent";

export type Props = Omit<
  SupportPageContentProps,
  | "onSearchClick"
  | "onSupportClick"
  | "onNavigationClick"
  | "articles"
  | "categories"
  | "isLoading"
> & {
  articleId?: string;
};

export function SupportPageContentContainer({
  children,
  articleId,
  title,
  description,
  ...props
}: Props) {
  const navigate = useNavigate();

  // Get data and loading state from React Query
  const { data, isLoading } = useFetchSupportArticles();
  const articles = data?.articles ?? [];
  const categories = data?.categories ?? [];

  const { setArticleId } = useSupportSheet();

  const { openDialog } = useDialog();

  const isSupportPage = useIsSupportPage();

  const handleSearchClick = () => {
    openDialog("supportSearch");
  };

  const handleSupportClick = () => {
    openDialog("supportTicket");
  };

  const handleNavigationClick = (article: Article) => {
    isSupportPage
      ? navigate(`/support/${article.id}`)
      : setArticleId(article.id);
  };

  const article = articles.find((article) => article.id === articleId);

  const computedTitle = article?.title ?? title;

  const computedDescription = article ? undefined : description;

  return (
    <SupportPageContent
      title={computedTitle}
      description={computedDescription}
      articles={articles}
      categories={categories}
      isLoading={isLoading}
      onNavigationClick={handleNavigationClick}
      onSearchClick={handleSearchClick}
      onSupportClick={handleSupportClick}
      {...props}
    >
      {children}
    </SupportPageContent>
  );
}

export default SupportPageContentContainer;

